// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import axios from 'axios';
// import { Box, Grid, Paper, Typography, Button, Snackbar, Alert, Chip, Stack, Checkbox, useMediaQuery, useTheme, TextField, InputAdornment, Card, CardContent, Avatar, CircularProgress } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import PersonIcon from '@mui/icons-material/Person';
// import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
// import EmailIcon from '@mui/icons-material/Email';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import SearchIcon from '@mui/icons-material/Search';
// import Dropdown from '../components/Dropdown';
// import { useAuth } from '../context/AuthContext';
// import { formatRows } from '../utils/formatRows';
// import NoDataComponent from '../components/NoDataComponent';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import CenterLoader from '../components/CenterLoader';

// /**
//  * Utility: Convert string to color
//  */
// const stringToColor = (string) => {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// };

// /**
//  * Utility: Get initials from name
//  */
// const getInitials = (name) => name?.trim().charAt(0).toUpperCase() || 'C';

// /**
//  * ReAssignInquiryDetails2 Component
//  * 
//  * Displays inquiries for reassignment with:
//  * - Server-side search and filtering
//  * - Select by assigned employee
//  * - Reassign to different employee
//  * - Mobile + Desktop views
//  * - Bulk reassignment
//  */
// const ReAssignInquiryDetails2 = ({ connectionString }) => {
//     const { user, selectedCompany } = useAuth();
//     const API = connectionString;
//     console.log(API);
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;

//     const allowedRoles = ["Team Leader", "Admin"];
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     // ============ STATE MANAGEMENT ============

//     // Shared state
//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     // Desktop state (DataGrid)
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);

//     // Mobile state (Search + Pagination)
//     const [mobileSearchQuery, setMobileSearchQuery] = useState('');
//     const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
//     const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

//     // Reassign state
//     const [selectedUserId, setSelectedUserId] = useState(null);
//     const [reAssignToUserId, setReAssignToUserId] = useState(null);
//     const [usersOptions, setUsersOptions] = useState([]);

//     console.log('=== REASSIGN PAGE RENDER ===');
//     console.log('selectionModel:', selectionModel);
//     console.log('selectedUserId:', selectedUserId);

//     // ============ PARAMETER BUILDERS ============

//     /**
//      * Build parameters for mobile search request
//      */
//     const buildMobileParams = (pageNum, searchText) => {
//         const offset = pageNum * 20;
//         const params = { mode: 'search', companyId, userId, role, offset, limit: 20 };

//         if (searchText && searchText.trim()) {
//             params.search = searchText;
//         }

//         console.log('📦 buildMobileParams:', params);
//         return params;
//     };

//     /**
//      * Build parameters for desktop request with filters and sort
//      */
//     const buildDesktopParams = (pageNum, pageSize) => {
//         const offset = pageNum * pageSize;
//         const params = { mode: 'search', companyId, userId, role, offset, limit: pageSize };

//         // Add filters from DataGrid
//         filterModel.items.forEach(item => {
//             if (item.value) {
//                 switch (item.field) {
//                     case 'FirmName': params.FirmName = item.value;
//                         break;
//                     case 'clientContact': params.clientContact = item.value;
//                         break;
//                     case 'MobileNo': params.MobileNo = item.value;
//                         break;
//                     case 'LastemployeeName': params.LastemployeeName = item.value;
//                         break;
//                     case 'StatusName': params.StatusName = item.value;
//                         break;
//                     default: break;
//                 }
//             }
//         });

//         // Add sorting
//         if (sortModel.length > 0) {
//             const sort = sortModel[0];
//             params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
//         }

//         console.log('🖥️ buildDesktopParams:', params);
//         return params;
//     };

//     // ============ FETCH FUNCTIONS ============

//     /**
//      * Fetch data for desktop view (with filters and sort)
//      */
//     const fetchDataDesktop = useCallback(async () => {
//         if (isSmallScreen) return;

//         console.log('🖥️ [DESKTOP] Fetching data...');
//         setLoading(true);
//         try {
//             const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/api/reassign-inquiry`, { params, companyId, userId });
//             const fetchedRows = Array.isArray(dataRes.data?.data) ? dataRes.data.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);

//             console.log(`🖥️ Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { companyId, userId, role };

//             // Add same filters as search
//             filterModel.items.forEach(item => {
//                 if (item.value) {
//                     switch (item.field) {
//                         case 'FirmName': countParams.FirmName = item.value;
//                             break;
//                         case 'clientContact': countParams.clientContact = item.value;
//                             break;
//                         case 'MobileNo': countParams.MobileNo = item.value;
//                             break;
//                         case 'LastemployeeName': countParams.LastemployeeName = item.value;
//                             break;
//                         case 'StatusName': countParams.StatusName = item.value;
//                             break;
//                         default: break;
//                     }
//                 }
//             });

//             const countRes = await axios.get(`${API}/api/reassign-inquiry-count`, { params: countParams, companyId, userId });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`🖥️ Total count: ${count}`);
//         } catch (err) {
//             console.error('🖥️ Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, role, paginationModel, filterModel, sortModel, isSmallScreen]);

//     /**
//      * Fetch data for mobile view (with search only)
//      */
//     const fetchDataMobile = useCallback(async () => {
//         console.log('📱 [MOBILE] Fetching data...');

//         if (!isSmallScreen) {
//             console.log('📱 Skipping - not small screen');
//             return;
//         }

//         setLoading(true);
//         try {
//             const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

//             console.log('📱 API URL:', `${API}/api/reassign-inquiry`);
//             console.log('📱 Params:', JSON.stringify(params, null, 2));

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/api/reassign-inquiry`, { params, companyId, userId });
//             const fetchedRows = Array.isArray(dataRes.data?.data) ? dataRes.data.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);

//             console.log(`📱 Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { companyId, userId, role };
//             if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
//                 countParams.search = debouncedMobileSearch;
//             }

//             console.log('📱 Count params:', countParams);
//             const countRes = await axios.get(`${API}/api/reassign-inquiry-count`, { params: countParams, companyId, userId });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`📱 Total count: ${count}`);
//         } catch (err) {
//             console.error('📱 Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, role, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

//     // ============ EFFECTS ============

//     /**
//      * Load users on mount
//      */
//     useEffect(() => {
//         (async () => {
//             try {
//                 const res = await axios.get(`${API}/api/users`, { params: { companyId } });
//                 setUsersOptions(res.data.data || []);
//             } catch (err) {
//                 console.error('Error loading users:', err);
//             }
//         })();
//     }, [API, companyId]);

//     /**
//      * Trigger desktop fetch when pagination, filters, or sort changes
//      */
//     useEffect(() => {
//         console.log('💻 [EFFECT] Desktop dependencies changed');
//         if (!isSmallScreen) {
//             fetchDataDesktop();
//         }
//     }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

//     /**
//      * Trigger mobile fetch when pagination changes
//      */
//     useEffect(() => {
//         console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [mobilePaginationModel, isSmallScreen, fetchDataMobile]);

//     /**
//      * Debounce mobile search
//      */
//     useEffect(() => {
//         console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

//         const timer = setTimeout(() => {
//             console.log('⏱️ [DEBOUNCE] Timer completed! Setting search to:', mobileSearchQuery);
//             setDebouncedMobileSearch(mobileSearchQuery);
//             setMobilePaginationModel({ page: 0, pageSize: 20 });
//         }, 400);

//         return () => {
//             console.log('⏱️ [DEBOUNCE] Cleared timeout');
//             clearTimeout(timer);
//         };
//     }, [mobileSearchQuery]);

//     /**
//      * Trigger fetch when debounced search changes
//      */
//     useEffect(() => {
//         console.log('📱 [EFFECT] Debounced search changed:', debouncedMobileSearch);
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

//     // ============ HANDLERS ============

//     const handleCheckboxChange = (rowId) => {
//         const row = rows.find(r => r.InqId === rowId);
//         if (!row) return;

//         const newSelection = selectionModel.includes(rowId)
//             ? selectionModel.filter(id => id !== rowId)
//             : [...selectionModel, rowId];

//         // Check if all selected rows have same assigned user
//         if (newSelection.length > 0) {
//             const selectedRows = rows.filter(r => newSelection.includes(r.InqId));
//             const uniqueUsers = new Set(selectedRows.map(r => r.LastuserId));

//             if (uniqueUsers.size > 1) {
//                 setSnackbar({ open: true, message: 'All selected inquiries must be assigned to the same employee.', severity: 'warning' });
//                 return;
//             }

//             setSelectedUserId(Array.from(uniqueUsers)[0]);
//         } else {
//             setSelectedUserId(null);
//         }

//         setSelectionModel(newSelection);
//     };

//     const handleHeaderCheckboxChange = () => {
//         if (selectionModel.length > 0) {
//             setSelectionModel([]);
//             setSelectedUserId(null);
//         } else if (rows.length > 0) {
//             const firstRow = rows[0];
//             const matchingRows = rows.filter(row => row.LastuserId === firstRow.LastuserId);
//             const newSelection = matchingRows.map(row => row.InqId);
//             setSelectionModel(newSelection);
//             setSelectedUserId(firstRow.LastuserId);
//         }
//     };

//     const getHeaderCheckboxProps = () => {
//         if (rows.length === 0) return { checked: false, indeterminate: false, disabled: true };

//         const matchingRows = selectedUserId !== null ? rows.filter(row => row.LastuserId === selectedUserId) : [];
//         const matchingRowIds = matchingRows.map(row => row.InqId);
//         const allSelected = matchingRows.length > 0 && matchingRowIds.every(id => selectionModel.includes(id));
//         const someSelected = selectionModel.length > 0 && matchingRowIds.some(id => selectionModel.includes(id)) && !allSelected;

//         return { checked: allSelected, indeterminate: someSelected, disabled: rows.length === 0 };
//     };

//     const handleSubmit = async () => {
//         if (!reAssignToUserId || selectionModel.length === 0) {
//             return setSnackbar({ open: true, message: 'Please select a target employee and inquiries.', severity: 'warning' });
//         }

//         if (selectedUserId === reAssignToUserId) {
//             return setSnackbar({ open: true, message: 'Current and target employees must be different.', severity: 'error' });
//         }

//         // Get the current employee name
//         const currentEmployee = usersOptions.find(u => u.UserId === selectedUserId);
//         const newEmployee = usersOptions.find(u => u.UserId === reAssignToUserId);

//         const payload = {
//             assign: currentEmployee?.employeeName || '',
//             assignId: selectedUserId,
//             reAssign: newEmployee?.employeeName || '',
//             reAssignId: reAssignToUserId,
//             inquiryIds: selectionModel
//         };

//         try {
//             await axios.post(`${API}/api/reassign-inquiries`, payload);
//             console.log(payload);
//             setSnackbar({ open: true, message: 'Inquiries reassigned successfully!', severity: 'success' });
//             handleReset();
//             if (isSmallScreen) {
//                 fetchDataMobile();
//             } else {
//                 fetchDataDesktop();
//             }
//         } catch (err) {
//             console.error('Reassignment error:', err);
//             setSnackbar({ open: true, message: 'Reassignment failed.', severity: 'error' });
//         }
//     };

//     const handleReset = () => {
//         setSelectionModel([]);
//         setSelectedUserId(null);
//         setReAssignToUserId(null);
//         setMobileSearchQuery('');
//         setPaginationModel({ page: 0, pageSize: 50 });
//         setFilterModel({ items: [] });
//     };

//     // ============ COLUMNS DEFINITION ============

//     const columns = [
//         {
//             field: 'selection',
//             headerName: '',
//             width: 70,
//             sortable: false,
//             filterable: false,
//             renderHeader: () => <Checkbox {...getHeaderCheckboxProps()} onChange={handleHeaderCheckboxChange} color="primary" />,
//             renderCell: (params) => <Checkbox checked={selectionModel.includes(params.row.InqId)} onChange={() => handleCheckboxChange(params.row.InqId)} color="primary" />
//         },
//         {
//             field: 'InqNo',
//             headerName: 'Inquiry No',
//             flex: 0.5,
//             minWidth: 120,
//             renderCell: ({ row }) => (
//                 <Box>
//                     <Typography variant="subtitle2">{row.InqNo || '-'}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                         {row.InqDate ? new Date(row.InqDate).toLocaleDateString('en-GB') : '-'}
//                     </Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'FirmName',
//             headerName: 'Client Info',
//             flex: 2,
//             minWidth: 250,
//             sortable: false,
//             filterable: true,
//             renderCell: ({ row }) => (
//                 <Box sx={{ my: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}>
//                         {row.FirmName}
//                     </Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <PersonIcon sx={{ color: '#FADA5E' }} fontSize="small" />
//                         <Typography variant="body2">{row.clientContact || '-'}</Typography>
//                     </Stack>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <PhoneAndroidIcon sx={{ color: '#555' }} fontSize="small" />
//                         <Typography variant="body2">{row.MobileNo || '-'}</Typography>
//                     </Stack>
//                     {row.EmailId && (
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <EmailIcon sx={{ color: '#555' }} fontSize="small" />
//                             <Typography variant="body2">{row.EmailId}</Typography>
//                         </Stack>
//                     )}
//                     {(row.Address || row.city) && (
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <LocationOnIcon sx={{ color: '#1877F2' }} fontSize="small" />
//                             <Typography variant="body2">{row.city || row.Address || ''}</Typography>
//                         </Stack>
//                     )}
//                 </Box>
//             )
//         },
//         {
//             field: 'OfferPrice',
//             headerName: 'Prices',
//             flex: 0.7,
//             minWidth: 120,
//             renderCell: ({ row }) => (
//                 <Box>
//                     <Typography variant="body2" sx={{ fontWeight: 600 }}>Offer: ₹{row.OfferPrice || "0.00"}</Typography>
//                     <Typography variant="body2" color="text.secondary">Closing: ₹{row.ClosingPrice || "0.00"}</Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'Priority',
//             headerName: 'Priority',
//             flex: 0.4,
//             minWidth: 100,
//             renderCell: ({ value }) => {
//                 const priority = (value || '').toLowerCase();
//                 let color = '#43a047';
//                 if (priority === 'high') color = '#e53935';
//                 else if (priority === 'mid') color = '#fbc02d';
//                 return <Typography variant="body2" sx={{ color, fontWeight: 600 }}>{value || '—'}</Typography>;
//             }
//         },
//         {
//             field: 'LastemployeeName',
//             headerName: 'Assigned To',
//             flex: 0.6,
//             minWidth: 120
//         },
//         {
//             field: 'StatusName',
//             headerName: 'Status',
//             flex: 0.4,
//             minWidth: 100,
//             renderCell: ({ value }) => {
//                 const status = value?.toLowerCase();
//                 let chipStyles = {};
//                 if (status === 'success') chipStyles = { bgcolor: 'success.main', color: '#fff' };
//                 else if (status === 'failed') chipStyles = { bgcolor: '#D32F2F', color: '#fff' };
//                 else chipStyles = { bgcolor: '#FF4C00', color: '#fff' };
//                 return <Chip label={value || '—'} size="small" sx={{ fontWeight: 600, ...chipStyles }} />;
//             }
//         }
//     ];

//     // ============ CARD RENDERING (MOBILE) ============

//     const renderCards = () => {
//         if (loading) {
//             return (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
//                     <CircularProgress />
//                 </Box>
//             );
//         }

//         if (rows.length === 0) {
//             return (
//                 <>
//                     {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
//                 </>
//             );
//         }

//         return rows.map((row) => {
//             const avatarColor = stringToColor(row.FirmName || 'Inquiry');
//             const initials = getInitials(row.FirmName);
//             const isSelected = selectionModel.includes(row.InqId);

//             return (
//                 <Card
//                     key={row.InqId}
//                     onClick={() => handleCheckboxChange(row.InqId)}
//                     sx={{
//                         mb: 2,
//                         borderRadius: 2,
//                         boxShadow: 3,
//                         cursor: 'pointer',
//                         border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
//                         '&:hover': { boxShadow: 6 }
//                     }}
//                 >
//                     <CardContent sx={{ p: 2 }}>
//                         <Grid container alignItems="center" spacing={2}>
//                             <Grid item>
//                                 <Checkbox
//                                     checked={isSelected}
//                                     onChange={() => handleCheckboxChange(row.InqId)}
//                                     onClick={(e) => e.stopPropagation()}
//                                 />
//                             </Grid>
//                             <Grid item xs>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                     <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 40, height: 40 }}>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//                                             {initials}
//                                         </Typography>
//                                     </Avatar>
//                                     <Box>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                             {row.FirmName || '—'}
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             {row.city || row.Address || '—'}
//                                         </Typography>
//                                     </Box>
//                                 </Box>

//                                 <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <PersonIcon fontSize="small" color="action" />
//                                         <Typography variant="body2">{row.clientContact || 'N/A'}</Typography>
//                                     </Box>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <PhoneAndroidIcon fontSize="small" color="primary" />
//                                         <Typography variant="body2" sx={{ color: 'primary.main' }}>
//                                             {row.MobileNo || 'N/A'}
//                                         </Typography>
//                                     </Box>
//                                     <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                         <Typography variant="body2" color="text.secondary">
//                                             Assigned: <strong>{row.LastemployeeName || 'Unknown'}</strong>
//                                         </Typography>
//                                         <Chip
//                                             label={row.StatusName || '—'}
//                                             size="small"
//                                             sx={{
//                                                 bgcolor: row.StatusName?.toLowerCase() === 'success'
//                                                     ? '#4caf50'
//                                                     : row.StatusName?.toLowerCase() === 'failed'
//                                                         ? '#d32f2f'
//                                                         : '#FF4C00',
//                                                 color: '#fff'
//                                             }}
//                                         />
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     // ============ PERMISSION CHECK ============

//     if (!allowedRoles.includes(role)) {
//         return (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
//                 <Typography variant="h5" fontWeight={600} color="error">
//                     403 Unauthorized Access
//                 </Typography>
//             </Box>
//         );
//     }

//     // ============ RENDER ============

//     return (
//         <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
//             <Typography
//                 variant="h5"
//                 sx={{
//                     textAlign: 'center',
//                     fontSize: { xs: '1.25rem', sm: '1.5rem' },
//                     fontWeight: 600, mb: 0.7
//                 }}
//             >
//                 Re-Assign Inquiry List
//             </Typography>

//             {/* Controls */}
//             <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//                 {/* Search field - visible only on small screens */}
//                 {isSmallScreen && (
//                     <Grid item xs={12}>
//                         <TextField
//                             fullWidth
//                             size="small"
//                             placeholder="Search by firm, contact or mobile..."
//                             value={mobileSearchQuery}
//                             onChange={(e) => setMobileSearchQuery(e.target.value)}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 )
//                             }}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                 '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                             }}
//                         />
//                     </Grid>
//                 )}

//                 <Grid item xs={12} md={5}>
//                     <Dropdown
//                         label="Re-Assign To"
//                         value={reAssignToUserId}
//                         options={usersOptions}
//                         valueKey="UserId"
//                         labelKey="employeeName"
//                         onChange={(selected) => setReAssignToUserId(selected.UserId)}
//                         fullWidth
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={7}>
//                     <Box sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'stretch', md: 'flex-end' } }}>
//                         <Button variant="contained" onClick={handleSubmit} fullWidth={isSmallScreen}>
//                             Submit
//                         </Button>
//                         <Button variant="outlined" onClick={handleReset} fullWidth={isSmallScreen}>
//                             Reset
//                         </Button>
//                     </Box>
//                 </Grid>
//             </Grid>

//             {/* Selected Count Bar (Mobile) */}
//             {isSmallScreen && selectionModel.length > 0 && (
//                 <Paper sx={{ p: 1.5, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Checkbox {...getHeaderCheckboxProps()} onChange={handleHeaderCheckboxChange} />
//                         <Typography>{selectionModel.length} selected</Typography>
//                     </Box>
//                 </Paper>
//             )}

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
//                 <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
//                     {isSmallScreen ? (
//                         <Box sx={{ p: 2, maxHeight: '70vh', overflowY: 'auto' }}>
//                             {renderCards()}
//                         </Box>
//                     ) : (
//                         <Box sx={{ height: '74vh', width: '100%' }}>
//                             {loading ? (
//                                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//                                     <CircularProgress />
//                                 </Box>
//                             ) : (<>
//                                 {
//                                     loading ? (
//                                         <CenterLoader />
//                                     ) : rows?.length === 0 ? (
//                                         <NoDataComponent />
//                                     ) : (
//                                         <DataGrid
//                                             rows={rows}
//                                             columns={columns}
//                                             getRowId={(r) => r.InqId}
//                                             checkboxSelection={false}
//                                             disableSelectionOnClick
//                                             getRowHeight={() => 'auto'}

//                                             sx={{
//                                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
//                                                 '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
//                                                 '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

//                                                 // Background styling
//                                                 '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
//                                                 '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

//                                                 // Row styling
//                                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
//                                                 '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

//                                                 // Selected row styling (with !important to override default MUI)
//                                                 '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

//                                                 // Cell content alignment
//                                                 '& .MuiDataGrid-cell': {
//                                                     display: 'flex',
//                                                     alignItems: 'center'
//                                                 },
//                                             }}
//                                             slots={{
//                                                 noResultsOverlay: CustomNoDataOverlay
//                                                 // Jab filter ka result 0 aaye
//                                             }}
//                                         />
//                                     )
//                                 }

//                             </>
//                             )
//                             }
//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={3000}
//                 onClose={() => setSnackbar(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//             >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// export default ReAssignInquiryDetails2;









// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import axios from 'axios';
// import { Box, Grid, Paper, Typography, Button, Snackbar, Alert, Chip, Stack, Checkbox, useMediaQuery, useTheme, TextField, InputAdornment, Card, CardContent, Avatar, CircularProgress } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import PersonIcon from '@mui/icons-material/Person';
// import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
// import EmailIcon from '@mui/icons-material/Email';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import SearchIcon from '@mui/icons-material/Search';
// import Dropdown from '../components/Dropdown';
// import { useAuth } from '../context/AuthContext';
// import { formatRows } from '../utils/formatRows';
// import NoDataComponent from '../components/NoDataComponent';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import CenterLoader from '../components/CenterLoader';

// /**
//  * Utility: Convert string to color
//  */
// const stringToColor = (string) => {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// };

// /**
//  * Utility: Get initials from name
//  */
// const getInitials = (name) => name?.trim().charAt(0).toUpperCase() || 'C';

// /**
//  * ReAssignInquiryDetails2 Component
//  */
// const ReAssignInquiryDetails2 = ({ connectionString }) => {
//     const { user, selectedCompany } = useAuth();
//     const API = connectionString;
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;

//     const allowedRoles = ["Team Leader", "Admin"];
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     // ============ STATE MANAGEMENT ============

//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     // Desktop state
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);

//     // ✅ NEW: Separate debounced filter and flag
//     const [debouncedFilterModel, setDebouncedFilterModel] = useState({ items: [] });
//     const [shouldFetch, setShouldFetch] = useState(false);
//     const filterDebounceRef = useRef(null);

//     // Mobile state
//     const [mobileSearchQuery, setMobileSearchQuery] = useState('');
//     const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
//     const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

//     // Reassign state
//     const [selectedUserId, setSelectedUserId] = useState(null);
//     const [reAssignToUserId, setReAssignToUserId] = useState(null);
//     const [usersOptions, setUsersOptions] = useState([]);

//     // ============ FETCH FUNCTIONS ============

//     /**
//      * Fetch data for desktop view
//      * ✅ CRITICAL: Uses debouncedFilterModel, not filterModel
//      */
//     const fetchDataDesktop = useCallback(async () => {
//         if (isSmallScreen) return;

//         console.log('🖥️ [DESKTOP FETCH] Starting...');
//         console.log('debouncedFilterModel:', JSON.stringify(debouncedFilterModel));

//         setLoading(true);
//         try {
//             const offset = paginationModel.page * paginationModel.pageSize;
//             const params = { companyId, userId, role, offset, limit: paginationModel.pageSize };

//             console.log('📝 Building params...');

//             // ✅ CRITICAL: Loop through debouncedFilterModel, NOT filterModel
//             if (debouncedFilterModel.items && debouncedFilterModel.items.length > 0) {
//                 debouncedFilterModel.items.forEach(item => {
//                     console.log(`📌 Processing filter item: field=${item.field}, value=${item.value}`);
//                     if (item.value && item.value.trim()) {
//                         switch (item.field) {
//                             case 'FirmName':
//                                 params.FirmName = item.value;
//                                 console.log(`✅ Added FirmName filter: ${item.value}`);
//                                 break;
//                             case 'clientContact':
//                                 params.clientContact = item.value;
//                                 console.log(`✅ Added clientContact filter: ${item.value}`);
//                                 break;
//                             case 'MobileNo':
//                                 params.MobileNo = item.value;
//                                 console.log(`✅ Added MobileNo filter: ${item.value}`);
//                                 break;
//                             case 'LastemployeeName':
//                                 params.LastemployeeName = item.value;
//                                 console.log(`✅ Added LastemployeeName filter: ${item.value}`);
//                                 break;
//                             case 'StatusName':
//                                 params.StatusName = item.value;
//                                 console.log(`✅ Added StatusName filter: ${item.value}`);
//                                 break;
//                             default:
//                                 console.log(`❓ Unknown filter field: ${item.field}`);
//                                 break;
//                         }
//                     }
//                 });
//             } else {
//                 console.log('ℹ️ No filters in debouncedFilterModel');
//             }

//             // Add sorting
//             if (sortModel.length > 0) {
//                 const sort = sortModel[0];
//                 params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
//             }

//             console.log('🚀 SENDING REQUEST with params:', JSON.stringify(params, null, 2));

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/api/reassign-inquiry`, { params });
//             console.log('✅ Response received:', dataRes.data);

//             const fetchedRows = Array.isArray(dataRes.data?.data) ? dataRes.data.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);

//             console.log(`✅ Fetched ${fetchedRows.length} rows`);

//             // Fetch total count
//             const countParams = { companyId, userId, role };

//             if (debouncedFilterModel.items && debouncedFilterModel.items.length > 0) {
//                 debouncedFilterModel.items.forEach(item => {
//                     if (item.value && item.value.trim()) {
//                         switch (item.field) {
//                             case 'FirmName': countParams.FirmName = item.value; break;
//                             case 'clientContact': countParams.clientContact = item.value; break;
//                             case 'MobileNo': countParams.MobileNo = item.value; break;
//                             case 'LastemployeeName': countParams.LastemployeeName = item.value; break;
//                             case 'StatusName': countParams.StatusName = item.value; break;
//                             default: break;
//                         }
//                     }
//                 });
//             }

//             const countRes = await axios.get(`${API}/api/reassign-inquiry-count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);

//             console.log(`✅ Total count: ${count}`);
//         } catch (err) {
//             console.error('❌ Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, role, paginationModel, debouncedFilterModel, sortModel, isSmallScreen]);

//     /**
//      * Fetch data for mobile view
//      */
//     const fetchDataMobile = useCallback(async () => {
//         if (!isSmallScreen) return;

//         console.log('📱 [MOBILE] Fetching data...');
//         setLoading(true);
//         try {
//             const offset = mobilePaginationModel.page * 20;
//             const params = { companyId, userId, role, offset, limit: 20 };

//             if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
//                 params.search = debouncedMobileSearch;
//             }

//             const dataRes = await axios.get(`${API}/api/reassign-inquiry`, { params });
//             const fetchedRows = Array.isArray(dataRes.data?.data) ? dataRes.data.data : [];
//             setRows(formatRows(fetchedRows));
//             setSelectionModel([]);

//             const countParams = { companyId, userId, role };
//             if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
//                 countParams.search = debouncedMobileSearch;
//             }

//             const countRes = await axios.get(`${API}/api/reassign-inquiry-count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);
//         } catch (err) {
//             console.error('📱 Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
//             setRows([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, role, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

//     // ============ EFFECTS ============

//     /**
//      * Load users on mount
//      */
//     useEffect(() => {
//         (async () => {
//             try {
//                 const res = await axios.get(`${API}/api/users`, { params: { companyId } });
//                 setUsersOptions(res.data.data || []);
//             } catch (err) {
//                 console.error('Error loading users:', err);
//             }
//         })();
//     }, [API, companyId]);

//     /**
//      * ✅ CRITICAL EFFECT: Debounce filter changes
//      * This prevents reloading on every keystroke
//      */
//     useEffect(() => {
//         console.log('⏱️ [FILTER DEBOUNCE] Timer started for:', filterModel);

//         if (filterDebounceRef.current) {
//             clearTimeout(filterDebounceRef.current);
//         }

//         filterDebounceRef.current = setTimeout(() => {
//             console.log('⏱️ [FILTER DEBOUNCE] Timer completed! Setting debouncedFilterModel');
//             console.log('filterModel before setting:', filterModel);
//             setDebouncedFilterModel(filterModel);
//             setPaginationModel({ page: 0, pageSize: 50 });
//             setShouldFetch(true);
//         }, 1500);

//         return () => {
//             if (filterDebounceRef.current) {
//                 clearTimeout(filterDebounceRef.current);
//             }
//         };
//     }, [filterModel]);

//     /**
//      * ✅ TRIGGER FETCH: When debouncedFilterModel or pagination changes
//      */
//     useEffect(() => {
//         console.log('💻 [EFFECT] Checking if should fetch...');
//         console.log('paginationModel:', paginationModel);
//         console.log('debouncedFilterModel:', debouncedFilterModel);
//         console.log('shouldFetch:', shouldFetch);

//         if (!isSmallScreen) {
//             fetchDataDesktop();
//         }
//     }, [paginationModel.page, paginationModel.pageSize, debouncedFilterModel, sortModel, isSmallScreen, fetchDataDesktop]);

//     /**
//      * Trigger mobile fetch when pagination changes
//      */
//     useEffect(() => {
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [mobilePaginationModel, isSmallScreen, fetchDataMobile]);

//     /**
//      * Debounce mobile search
//      */
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setDebouncedMobileSearch(mobileSearchQuery);
//             setMobilePaginationModel({ page: 0, pageSize: 20 });
//         }, 4000);

//         return () => clearTimeout(timer);
//     }, [mobileSearchQuery]);

//     /**
//      * Trigger fetch when debounced search changes
//      */
//     useEffect(() => {
//         if (isSmallScreen) {
//             fetchDataMobile();
//         }
//     }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

//     // ============ HANDLERS ============

//     const handleCheckboxChange = (rowId) => {
//         const row = rows.find(r => r.InqId === rowId);
//         if (!row) return;

//         const newSelection = selectionModel.includes(rowId)
//             ? selectionModel.filter(id => id !== rowId)
//             : [...selectionModel, rowId];

//         if (newSelection.length > 0) {
//             const selectedRows = rows.filter(r => newSelection.includes(r.InqId));
//             const uniqueUsers = new Set(selectedRows.map(r => r.LastuserId));

//             if (uniqueUsers.size > 1) {
//                 setSnackbar({ open: true, message: 'All selected inquiries must be assigned to the same employee.', severity: 'warning' });
//                 return;
//             }

//             setSelectedUserId(Array.from(uniqueUsers)[0]);
//         } else {
//             setSelectedUserId(null);
//         }

//         setSelectionModel(newSelection);
//     };

//     const handleHeaderCheckboxChange = () => {
//         if (selectionModel.length > 0) {
//             setSelectionModel([]);
//             setSelectedUserId(null);
//         } else if (rows.length > 0) {
//             const firstRow = rows[0];
//             const matchingRows = rows.filter(row => row.LastuserId === firstRow.LastuserId);
//             const newSelection = matchingRows.map(row => row.InqId);
//             setSelectionModel(newSelection);
//             setSelectedUserId(firstRow.LastuserId);
//         }
//     };

//     const getHeaderCheckboxProps = () => {
//         if (rows.length === 0) return { checked: false, indeterminate: false, disabled: true };

//         const matchingRows = selectedUserId !== null ? rows.filter(row => row.LastuserId === selectedUserId) : [];
//         const matchingRowIds = matchingRows.map(row => row.InqId);
//         const allSelected = matchingRows.length > 0 && matchingRowIds.every(id => selectionModel.includes(id));
//         const someSelected = selectionModel.length > 0 && matchingRowIds.some(id => selectionModel.includes(id)) && !allSelected;

//         return { checked: allSelected, indeterminate: someSelected, disabled: rows.length === 0 };
//     };

//     const handleSubmit = async () => {
//         if (!reAssignToUserId || selectionModel.length === 0) {
//             return setSnackbar({ open: true, message: 'Please select a target employee and inquiries.', severity: 'warning' });
//         }

//         if (selectedUserId === reAssignToUserId) {
//             return setSnackbar({ open: true, message: 'Current and target employees must be different.', severity: 'error' });
//         }

//         const currentEmployee = usersOptions.find(u => u.UserId === selectedUserId);
//         const newEmployee = usersOptions.find(u => u.UserId === reAssignToUserId);

//         const payload = {
//             assign: currentEmployee?.employeeName || '',
//             assignId: selectedUserId,
//             reAssign: newEmployee?.employeeName || '',
//             reAssignId: reAssignToUserId,
//             inquiryIds: selectionModel
//         };

//         try {
//             await axios.post(`${API}/api/reassign-inquiries`, payload);
//             setSnackbar({ open: true, message: 'Inquiries reassigned successfully!', severity: 'success' });
//             handleReset();
//             if (isSmallScreen) {
//                 fetchDataMobile();
//             } else {
//                 fetchDataDesktop();
//             }
//         } catch (err) {
//             console.error('Reassignment error:', err);
//             setSnackbar({ open: true, message: 'Reassignment failed.', severity: 'error' });
//         }
//     };

//     const handleReset = () => {
//         setSelectionModel([]);
//         setSelectedUserId(null);
//         setReAssignToUserId(null);
//         setMobileSearchQuery('');
//         setPaginationModel({ page: 0, pageSize: 50 });
//         setFilterModel({ items: [] });
//         setDebouncedFilterModel({ items: [] });
//     };

//     // ============ COLUMNS DEFINITION ============

//     const columns = [
//         {
//             field: 'selection',
//             headerName: '',
//             width: 70,
//             sortable: false,
//             filterable: false,
//             renderHeader: () => <Checkbox {...getHeaderCheckboxProps()} onChange={handleHeaderCheckboxChange} color="primary" />,
//             renderCell: (params) => <Checkbox checked={selectionModel.includes(params.row.InqId)} onChange={() => handleCheckboxChange(params.row.InqId)} color="primary" />
//         },
//         {
//             field: 'InqNo',
//             headerName: 'Inquiry No',
//             flex: 0.5,
//             minWidth: 120,
//             renderCell: ({ row }) => (
//                 <Box>
//                     <Typography variant="subtitle2">{row.InqNo || '-'}</Typography>
//                     <Typography variant="body2" color="text.secondary">
//                         {row.InqDate ? new Date(row.InqDate).toLocaleDateString('en-GB') : '-'}
//                     </Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'FirmName',
//             headerName: 'Client Info',
//             flex: 2,
//             minWidth: 250,
//             sortable: false,
//             filterable: true,
//             renderCell: ({ row }) => (
//                 <Box sx={{ my: 1 }}>
//                     <Typography variant="subtitle2" sx={{ color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}>
//                         {row.FirmName}
//                     </Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <PersonIcon sx={{ color: '#FADA5E' }} fontSize="small" />
//                         <Typography variant="body2">{row.clientContact || '-'}</Typography>
//                     </Stack>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <PhoneAndroidIcon sx={{ color: '#555' }} fontSize="small" />
//                         <Typography variant="body2">{row.MobileNo || '-'}</Typography>
//                     </Stack>
//                     {row.EmailId && (
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <EmailIcon sx={{ color: '#555' }} fontSize="small" />
//                             <Typography variant="body2">{row.EmailId}</Typography>
//                         </Stack>
//                     )}
//                     {(row.Address || row.city) && (
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <LocationOnIcon sx={{ color: '#1877F2' }} fontSize="small" />
//                             <Typography variant="body2">{row.city || row.Address || ''}</Typography>
//                         </Stack>
//                     )}
//                 </Box>
//             )
//         },
//         {
//             field: 'OfferPrice',
//             headerName: 'Prices',
//             flex: 0.7,
//             minWidth: 120,
//             renderCell: ({ row }) => (
//                 <Box>
//                     <Typography variant="body2" sx={{ fontWeight: 600 }}>Offer: ₹{row.OfferPrice || "0.00"}</Typography>
//                     <Typography variant="body2" color="text.secondary">Closing: ₹{row.ClosingPrice || "0.00"}</Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'Priority',
//             headerName: 'Priority',
//             flex: 0.4,
//             minWidth: 100,
//             renderCell: ({ value }) => {
//                 const priority = (value || '').toLowerCase();
//                 let color = '#43a047';
//                 if (priority === 'high') color = '#e53935';
//                 else if (priority === 'mid') color = '#fbc02d';
//                 return <Typography variant="body2" sx={{ color, fontWeight: 600 }}>{value || '—'}</Typography>;
//             }
//         },
//         {
//             field: 'LastemployeeName',
//             headerName: 'Assigned To',
//             flex: 0.6,
//             minWidth: 120,
//             filterable: true
//         },
//         {
//             field: 'StatusName',
//             headerName: 'Status',
//             flex: 0.4,
//             minWidth: 100,
//             filterable: true,
//             renderCell: ({ value }) => {
//                 const status = value?.toLowerCase();
//                 let chipStyles = {};
//                 if (status === 'success') chipStyles = { bgcolor: 'success.main', color: '#fff' };
//                 else if (status === 'failed') chipStyles = { bgcolor: '#D32F2F', color: '#fff' };
//                 else chipStyles = { bgcolor: '#FF4C00', color: '#fff' };
//                 return <Chip label={value || '—'} size="small" sx={{ fontWeight: 600, ...chipStyles }} />;
//             }
//         }
//     ];

//     // ============ CARD RENDERING (MOBILE) ============

//     const renderCards = () => {
//         if (loading) {
//             return (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
//                     <CircularProgress />
//                 </Box>
//             );
//         }

//         if (rows.length === 0) {
//             return (
//                 <>
//                     {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
//                 </>
//             );
//         }

//         return rows.map((row) => {
//             const avatarColor = stringToColor(row.FirmName || 'Inquiry');
//             const initials = getInitials(row.FirmName);
//             const isSelected = selectionModel.includes(row.InqId);

//             return (
//                 <Card
//                     key={row.InqId}
//                     onClick={() => handleCheckboxChange(row.InqId)}
//                     sx={{
//                         mb: 2,
//                         borderRadius: 2,
//                         boxShadow: 3,
//                         cursor: 'pointer',
//                         border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
//                         '&:hover': { boxShadow: 6 }
//                     }}
//                 >
//                     <CardContent sx={{ p: 2 }}>
//                         <Grid container alignItems="center" spacing={2}>
//                             <Grid item>
//                                 <Checkbox
//                                     checked={isSelected}
//                                     onChange={() => handleCheckboxChange(row.InqId)}
//                                     onClick={(e) => e.stopPropagation()}
//                                 />
//                             </Grid>
//                             <Grid item xs>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                     <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 40, height: 40 }}>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
//                                             {initials}
//                                         </Typography>
//                                     </Avatar>
//                                     <Box>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
//                                             {row.FirmName || '—'}
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             {row.city || row.Address || '—'}
//                                         </Typography>
//                                     </Box>
//                                 </Box>

//                                 <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <PersonIcon fontSize="small" color="action" />
//                                         <Typography variant="body2">{row.clientContact || 'N/A'}</Typography>
//                                     </Box>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <PhoneAndroidIcon fontSize="small" color="primary" />
//                                         <Typography variant="body2" sx={{ color: 'primary.main' }}>
//                                             {row.MobileNo || 'N/A'}
//                                         </Typography>
//                                     </Box>
//                                     <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                         <Typography variant="body2" color="text.secondary">
//                                             Assigned: <strong>{row.LastemployeeName || 'Unknown'}</strong>
//                                         </Typography>
//                                         <Chip
//                                             label={row.StatusName || '—'}
//                                             size="small"
//                                             sx={{
//                                                 bgcolor: row.StatusName?.toLowerCase() === 'success'
//                                                     ? '#4caf50'
//                                                     : row.StatusName?.toLowerCase() === 'failed'
//                                                         ? '#d32f2f'
//                                                         : '#FF4C00',
//                                                 color: '#fff'
//                                             }}
//                                         />
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     // ============ PERMISSION CHECK ============

//     if (!allowedRoles.includes(role)) {
//         return (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
//                 <Typography variant="h5" fontWeight={600} color="error">
//                     403 Unauthorized Access
//                 </Typography>
//             </Box>
//         );
//     }

//     // ============ RENDER ============

//     return (
//         <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
//             <Typography
//                 variant="h5"
//                 sx={{
//                     textAlign: 'center',
//                     fontSize: { xs: '1.25rem', sm: '1.5rem' },
//                     fontWeight: 600, mb: 0.7
//                 }}
//             >
//                 Re-Assign Inquiry List
//             </Typography>

//             {/* Controls */}
//             <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//                 {isSmallScreen && (
//                     <Grid item xs={12}>
//                         <TextField
//                             fullWidth
//                             size="small"
//                             placeholder="Search by firm, contact or mobile..."
//                             value={mobileSearchQuery}
//                             onChange={(e) => setMobileSearchQuery(e.target.value)}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 )
//                             }}
//                             sx={{
//                                 '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                 '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                             }}
//                         />
//                     </Grid>
//                 )}

//                 <Grid item xs={12} md={5}>
//                     <Dropdown
//                         label="Re-Assign To"
//                         value={reAssignToUserId}
//                         options={usersOptions}
//                         valueKey="UserId"
//                         labelKey="employeeName"
//                         onChange={(selected) => setReAssignToUserId(selected.UserId)}
//                         fullWidth
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={7}>
//                     <Box sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'stretch', md: 'flex-end' } }}>
//                         <Button variant="contained" onClick={handleSubmit} fullWidth={isSmallScreen}>
//                             Submit
//                         </Button>
//                         <Button variant="outlined" onClick={handleReset} fullWidth={isSmallScreen}>
//                             Reset
//                         </Button>
//                     </Box>
//                 </Grid>
//             </Grid>

//             {/* Selected Count Bar (Mobile) */}
//             {isSmallScreen && selectionModel.length > 0 && (
//                 <Paper sx={{ p: 1.5, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <Checkbox {...getHeaderCheckboxProps()} onChange={handleHeaderCheckboxChange} />
//                         <Typography>{selectionModel.length} selected</Typography>
//                     </Box>
//                 </Paper>
//             )}

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
//                 <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
//                     {isSmallScreen ? (
//                         <Box sx={{ p: 2, maxHeight: '70vh', overflowY: 'auto' }}>
//                             {renderCards()}
//                         </Box>
//                     ) : (
//                         <Box sx={{ height: '74vh', width: '100%' }}>
//                             {loading ? (
//                                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//                                     <CircularProgress />
//                                 </Box>
//                             ) : (
//                                 <>
//                                     {rows?.length === 0 ? (
//                                         <NoDataComponent />
//                                     ) : (
//                                         <DataGrid
//                                             rows={rows}
//                                             columns={columns}
//                                             getRowId={(r) => r.InqId}

//                                             pagination
//                                             paginationMode="server"
//                                             rowCount={totalCount}

//                                             paginationModel={paginationModel}
//                                             onPaginationModelChange={(model) => setPaginationModel(model)}

//                                             pageSizeOptions={[25, 50, 100]}
//                                             loading={loading}
//                                             checkboxSelection={false}
//                                             disableSelectionOnClick
//                                             getRowHeight={() => 'auto'}

//                                             filterMode="server"
//                                             filterModel={filterModel}
//                                             onFilterModelChange={setFilterModel}

//                                             sortingMode="server"
//                                             sortModel={sortModel}
//                                             onSortModelChange={setSortModel}

//                                             sx={{
//                                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
//                                                 '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
//                                                 '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },
//                                                 '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
//                                                 '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },
//                                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
//                                                 '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },
//                                                 '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },
//                                                 '& .MuiDataGrid-cell': {
//                                                     display: 'flex',
//                                                     alignItems: 'center'
//                                                 },
//                                             }}
//                                             slots={{
//                                                 noResultsOverlay: CustomNoDataOverlay
//                                             }}
//                                         />
//                                     )
//                                     }
//                                 </>
//                             )}
//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={3000}
//                 onClose={() => setSnackbar(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//             >
//                 <Alert severity={snackbar.severity} variant="filled">
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// export default ReAssignInquiryDetails2;




















import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Box, Grid, Paper, Typography, Button, Snackbar, Alert, Chip, Stack, Checkbox, useMediaQuery, useTheme, TextField, InputAdornment, Card, CardContent, Avatar, CircularProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import PersonIcon from '@mui/icons-material/Person';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SearchIcon from '@mui/icons-material/Search';
import Dropdown from '../components/Dropdown';
import { useAuth } from '../context/AuthContext';
import { formatRows } from '../utils/formatRows';
import NoDataComponent from '../components/NoDataComponent';
import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
import CenterLoader from '../components/CenterLoader';

/**
 * Utility: Convert string to color
 */
const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
};

const normalizeFilterItems = (items = []) =>
    items
        .filter(i => i.value && i.value.trim() !== '')
        .map(i => `${i.field}:${i.value}`)
        .sort()
        .join('|');

/**
 * Utility: Get initials from name
 */
const getInitials = (name) => name?.trim().charAt(0).toUpperCase() || 'C';

/**
 * ReAssignInquiryDetails2 Component
 */
const ReAssignInquiryDetails2 = ({ connectionString }) => {
    const { user, selectedCompany } = useAuth();
    const API = connectionString;
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory;

    const allowedRoles = ["Team Leader", "Admin"];
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    // ============ STATE MANAGEMENT ============

    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Desktop state
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // ✅ NEW: Separate debounced filter and flag
    const [debouncedFilterModel, setDebouncedFilterModel] = useState({ items: [] });
    const [shouldFetch, setShouldFetch] = useState(false);
    const filterDebounceRef = useRef(null);

    // Mobile state
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

    // Reassign state
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [reAssignToUserId, setReAssignToUserId] = useState(null);
    const [usersOptions, setUsersOptions] = useState([]);
    const prevFilterRef = useRef('');

    // ============ FETCH FUNCTIONS ============

    /**
     * Fetch data for desktop view
     * ✅ CRITICAL: Uses debouncedFilterModel, not filterModel
     */
    const fetchDataDesktop = useCallback(async () => {
        if (isSmallScreen) return;

        console.log('🖥️ [DESKTOP FETCH] Starting...');
        console.log('debouncedFilterModel:', JSON.stringify(debouncedFilterModel));

        setLoading(true);
        try {
            const offset = paginationModel.page * paginationModel.pageSize;
            const params = { companyId, userId, role, offset, limit: paginationModel.pageSize };

            console.log('📝 Building params...');

            // ✅ CRITICAL: Loop through debouncedFilterModel, NOT filterModel
            if (debouncedFilterModel.items && debouncedFilterModel.items.length > 0) {
                debouncedFilterModel.items.forEach(item => {
                    console.log(`📌 Processing filter item: field=${item.field}, value=${item.value}`);
                    if (item.value && item.value.trim()) {
                        switch (item.field) {
                            case 'FirmName':
                                params.FirmName = item.value;
                                console.log(`✅ Added FirmName filter: ${item.value}`);
                                break;
                            case 'clientContact':
                                params.clientContact = item.value;
                                console.log(`✅ Added clientContact filter: ${item.value}`);
                                break;
                            case 'MobileNo':
                                params.MobileNo = item.value;
                                console.log(`✅ Added MobileNo filter: ${item.value}`);
                                break;
                            case 'LastemployeeName':
                                params.LastemployeeName = item.value;
                                console.log(`✅ Added LastemployeeName filter: ${item.value}`);
                                break;
                            case 'StatusName':
                                params.StatusName = item.value;
                                console.log(`✅ Added StatusName filter: ${item.value}`);
                                break;
                            default:
                                console.log(`❓ Unknown filter field: ${item.field}`);
                                break;
                        }
                    }
                });
            } else {
                console.log('ℹ️ No filters in debouncedFilterModel');
            }

            // Add sorting
            if (sortModel.length > 0) {
                const sort = sortModel[0];
                params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
            }

            console.log('🚀 SENDING REQUEST with params:', JSON.stringify(params, null, 2));

            // Fetch rows
            const dataRes = await axios.get(`${API}/api/reassign-inquiry`, { params });
            console.log('✅ Response received:', dataRes.data);

            const fetchedRows = Array.isArray(dataRes.data?.data) ? dataRes.data.data : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);

            console.log(`✅ Fetched ${fetchedRows.length} rows`);

            // Fetch total count
            const countParams = { companyId, userId, role };

            if (debouncedFilterModel.items && debouncedFilterModel.items.length > 0) {
                debouncedFilterModel.items.forEach(item => {
                    if (item.value && item.value.trim()) {
                        switch (item.field) {
                            case 'FirmName': countParams.FirmName = item.value; break;
                            case 'clientContact': countParams.clientContact = item.value; break;
                            case 'MobileNo': countParams.MobileNo = item.value; break;
                            case 'LastemployeeName': countParams.LastemployeeName = item.value; break;
                            case 'StatusName': countParams.StatusName = item.value; break;
                            default: break;
                        }
                    }
                });
            }

            const countRes = await axios.get(`${API}/api/reassign-inquiry-count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);

            console.log(`✅ Total count: ${count}`);
        } catch (err) {
            console.error('❌ Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, companyId, userId, role, paginationModel, debouncedFilterModel, sortModel, isSmallScreen]);

    /**
     * Fetch data for mobile view
     */
    const fetchDataMobile = useCallback(async () => {
        if (!isSmallScreen) return;

        console.log('📱 [MOBILE] Fetching data...');
        setLoading(true);
        try {
            const offset = mobilePaginationModel.page * 20;
            const params = { companyId, userId, role, offset, limit: 20 };

            if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
                params.search = debouncedMobileSearch;
            }

            const dataRes = await axios.get(`${API}/api/reassign-inquiry`, { params });
            const fetchedRows = Array.isArray(dataRes.data?.data) ? dataRes.data.data : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);

            const countParams = { companyId, userId, role };
            if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
                countParams.search = debouncedMobileSearch;
            }

            const countRes = await axios.get(`${API}/api/reassign-inquiry-count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
        } catch (err) {
            console.error('📱 Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, companyId, userId, role, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

    // ============ EFFECTS ============

    /**
     * Load users on mount
     */
    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API}/api/users`, { params: { companyId } });
                setUsersOptions(res.data.data || []);
            } catch (err) {
                console.error('Error loading users:', err);
            }
        })();
    }, [API, companyId]);

    /**
     * ✅ CRITICAL EFFECT: Debounce filter changes
     * This prevents reloading on every keystroke
     */
    // useEffect(() => {
    //     console.log('⏱️ [FILTER DEBOUNCE] Timer started for:', filterModel);

    //     if (filterDebounceRef.current) {
    //         clearTimeout(filterDebounceRef.current);
    //     }

    //     filterDebounceRef.current = setTimeout(() => {
    //         console.log('⏱️ [FILTER DEBOUNCE] Timer completed! Setting debouncedFilterModel');
    //         console.log('filterModel before setting:', filterModel);
    //         setDebouncedFilterModel(filterModel);
    //         setPaginationModel({ page: 0, pageSize: 50 });
    //         setShouldFetch(true);
    //     }, 1500);

    //     return () => {
    //         if (filterDebounceRef.current) {
    //             clearTimeout(filterDebounceRef.current);
    //         }
    //     };
    // }, [filterModel]);

    useEffect(() => {
        const currentFilterKey = normalizeFilterItems(filterModel.items);
        const prevFilterKey = prevFilterRef.current;

        // ❌ Stop reload when only opening filter UI
        if (currentFilterKey === prevFilterKey) {
            return;
        }

        if (filterDebounceRef.current) {
            clearTimeout(filterDebounceRef.current);
        }

        filterDebounceRef.current = setTimeout(() => {
            prevFilterRef.current = currentFilterKey;

            setDebouncedFilterModel(filterModel);
            setPaginationModel({ page: 0, pageSize: 50 });
        }, 1500);

        return () => {
            if (filterDebounceRef.current) {
                clearTimeout(filterDebounceRef.current);
            }
        };
    }, [filterModel]);


    /**
     * ✅ TRIGGER FETCH: When debouncedFilterModel or pagination changes
     */
    useEffect(() => {
        console.log('💻 [EFFECT] Checking if should fetch...');
        console.log('paginationModel:', paginationModel);
        console.log('debouncedFilterModel:', debouncedFilterModel);
        console.log('shouldFetch:', shouldFetch);

        if (!isSmallScreen) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, debouncedFilterModel, sortModel, isSmallScreen, fetchDataDesktop]);

    /**
     * Trigger mobile fetch when pagination changes
     */
    useEffect(() => {
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel, isSmallScreen, fetchDataMobile]);

    /**
     * Debounce mobile search
     */
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: 20 });
        }, 4000);

        return () => clearTimeout(timer);
    }, [mobileSearchQuery]);

    /**
     * Trigger fetch when debounced search changes
     */
    useEffect(() => {
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

    // ============ HANDLERS ============

    const handleCheckboxChange = (rowId) => {
        const row = rows.find(r => r.InqId === rowId);
        if (!row) return;

        const newSelection = selectionModel.includes(rowId)
            ? selectionModel.filter(id => id !== rowId)
            : [...selectionModel, rowId];

        if (newSelection.length > 0) {
            const selectedRows = rows.filter(r => newSelection.includes(r.InqId));
            const uniqueUsers = new Set(selectedRows.map(r => r.LastuserId));

            if (uniqueUsers.size > 1) {
                setSnackbar({ open: true, message: 'All selected inquiries must be assigned to the same employee.', severity: 'warning' });
                return;
            }

            setSelectedUserId(Array.from(uniqueUsers)[0]);
        } else {
            setSelectedUserId(null);
        }

        setSelectionModel(newSelection);
    };

    const handleHeaderCheckboxChange = () => {
        if (selectionModel.length > 0) {
            setSelectionModel([]);
            setSelectedUserId(null);
        } else if (rows.length > 0) {
            const firstRow = rows[0];
            const matchingRows = rows.filter(row => row.LastuserId === firstRow.LastuserId);
            const newSelection = matchingRows.map(row => row.InqId);
            setSelectionModel(newSelection);
            setSelectedUserId(firstRow.LastuserId);
        }
    };

    const getHeaderCheckboxProps = () => {
        if (rows.length === 0) return { checked: false, indeterminate: false, disabled: true };

        const matchingRows = selectedUserId !== null ? rows.filter(row => row.LastuserId === selectedUserId) : [];
        const matchingRowIds = matchingRows.map(row => row.InqId);
        const allSelected = matchingRows.length > 0 && matchingRowIds.every(id => selectionModel.includes(id));
        const someSelected = selectionModel.length > 0 && matchingRowIds.some(id => selectionModel.includes(id)) && !allSelected;

        return { checked: allSelected, indeterminate: someSelected, disabled: rows.length === 0 };
    };

    const handleSubmit = async () => {
        if (!reAssignToUserId || selectionModel.length === 0) {
            return setSnackbar({ open: true, message: 'Please select a target employee and inquiries.', severity: 'warning' });
        }

        if (selectedUserId === reAssignToUserId) {
            return setSnackbar({ open: true, message: 'Current and target employees must be different.', severity: 'error' });
        }

        const currentEmployee = usersOptions.find(u => u.UserId === selectedUserId);
        const newEmployee = usersOptions.find(u => u.UserId === reAssignToUserId);

        const payload = {
            assign: currentEmployee?.employeeName || '',
            assignId: selectedUserId,
            reAssign: newEmployee?.employeeName || '',
            reAssignId: reAssignToUserId,
            inquiryIds: selectionModel
        };

        try {
            await axios.post(`${API}/api/reassign-inquiries`, payload);
            setSnackbar({ open: true, message: 'Inquiries reassigned successfully!', severity: 'success' });
            handleReset();
            if (isSmallScreen) {
                fetchDataMobile();
            } else {
                fetchDataDesktop();
            }
        } catch (err) {
            console.error('Reassignment error:', err);
            setSnackbar({ open: true, message: 'Reassignment failed.', severity: 'error' });
        }
    };

    const handleReset = () => {
        setSelectionModel([]);
        setSelectedUserId(null);
        setReAssignToUserId(null);
        setMobileSearchQuery('');
        setPaginationModel({ page: 0, pageSize: 50 });
        setFilterModel({ items: [] });
        setDebouncedFilterModel({ items: [] });
    };

    // ============ COLUMNS DEFINITION ============

    const columns = [
        {
            field: 'selection',
            headerName: '',
            width: 70,
            sortable: false,
            filterable: false,
            renderHeader: () => <Checkbox {...getHeaderCheckboxProps()} onChange={handleHeaderCheckboxChange} color="primary" />,
            renderCell: (params) => <Checkbox checked={selectionModel.includes(params.row.InqId)} onChange={() => handleCheckboxChange(params.row.InqId)} color="primary" />
        },
        {
            field: 'InqNo',
            headerName: 'Inquiry No',
            flex: 0.5,
            minWidth: 120,
            renderCell: ({ row }) => (
                <Box>
                    <Typography variant="subtitle2">{row.InqNo || '-'}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {row.InqDate ? new Date(row.InqDate).toLocaleDateString('en-GB') : '-'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'FirmName',
            headerName: 'Client Info',
            flex: 2,
            minWidth: 250,
            sortable: false,
            filterable: true,
            renderCell: ({ row }) => (
                <Box sx={{ my: 1 }}>
                    <Typography variant="subtitle2" sx={{ color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}>
                        {row.FirmName}
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <PersonIcon sx={{ color: '#FADA5E' }} fontSize="small" />
                        <Typography variant="body2">{row.clientContact || '-'}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <PhoneAndroidIcon sx={{ color: '#555' }} fontSize="small" />
                        <Typography variant="body2">{row.MobileNo || '-'}</Typography>
                    </Stack>
                    {row.EmailId && (
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <EmailIcon sx={{ color: '#555' }} fontSize="small" />
                            <Typography variant="body2">{row.EmailId}</Typography>
                        </Stack>
                    )}
                    {(row.Address || row.city) && (
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <LocationOnIcon sx={{ color: '#1877F2' }} fontSize="small" />
                            <Typography variant="body2">{row.city || row.Address || ''}</Typography>
                        </Stack>
                    )}
                </Box>
            )
        },
        {
            field: 'OfferPrice',
            headerName: 'Prices',
            flex: 0.7,
            minWidth: 120,
            renderCell: ({ row }) => (
                <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>Offer: ₹{row.OfferPrice || "0.00"}</Typography>
                    <Typography variant="body2" color="text.secondary">Closing: ₹{row.ClosingPrice || "0.00"}</Typography>
                </Box>
            )
        },
        {
            field: 'Priority',
            headerName: 'Priority',
            flex: 0.4,
            minWidth: 100,
            renderCell: ({ value }) => {
                const priority = (value || '').toLowerCase();
                let color = '#43a047';
                if (priority === 'high') color = '#e53935';
                else if (priority === 'mid') color = '#fbc02d';
                return <Typography variant="body2" sx={{ color, fontWeight: 600 }}>{value || '—'}</Typography>;
            }
        },
        {
            field: 'LastemployeeName',
            headerName: 'Assigned To',
            flex: 0.6,
            minWidth: 120,
            filterable: true
        },
        {
            field: 'StatusName',
            headerName: 'Status',
            flex: 0.4,
            minWidth: 100,
            filterable: true,
            renderCell: ({ value }) => {
                const status = value?.toLowerCase();
                let chipStyles = {};
                if (status === 'success') chipStyles = { bgcolor: 'success.main', color: '#fff' };
                else if (status === 'failed') chipStyles = { bgcolor: '#D32F2F', color: '#fff' };
                else chipStyles = { bgcolor: '#FF4C00', color: '#fff' };
                return <Chip label={value || '—'} size="small" sx={{ fontWeight: 600, ...chipStyles }} />;
            }
        }
    ];

    // ============ CARD RENDERING (MOBILE) ============

    const renderCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (rows.length === 0) {
            return (
                <>
                    {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
                </>
            );
        }

        return rows.map((row) => {
            const avatarColor = stringToColor(row.FirmName || 'Inquiry');
            const initials = getInitials(row.FirmName);
            const isSelected = selectionModel.includes(row.InqId);

            return (
                <Card
                    key={row.InqId}
                    onClick={() => handleCheckboxChange(row.InqId)}
                    sx={{
                        mb: 2,
                        borderRadius: 2,
                        boxShadow: 3,
                        cursor: 'pointer',
                        border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                        '&:hover': { boxShadow: 6 }
                    }}
                >
                    <CardContent sx={{ p: 2 }}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <Checkbox
                                    checked={isSelected}
                                    onChange={() => handleCheckboxChange(row.InqId)}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </Grid>
                            <Grid item xs>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 40, height: 40 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                            {initials}
                                        </Typography>
                                    </Avatar>
                                    <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                            {row.FirmName || '—'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {row.city || row.Address || '—'}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <PersonIcon fontSize="small" color="action" />
                                        <Typography variant="body2">{row.clientContact || 'N/A'}</Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <PhoneAndroidIcon fontSize="small" color="primary" />
                                        <Typography variant="body2" sx={{ color: 'primary.main' }}>
                                            {row.MobileNo || 'N/A'}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Assigned: <strong>{row.LastemployeeName || 'Unknown'}</strong>
                                        </Typography>
                                        <Chip
                                            label={row.StatusName || '—'}
                                            size="small"
                                            sx={{
                                                bgcolor: row.StatusName?.toLowerCase() === 'success'
                                                    ? '#4caf50'
                                                    : row.StatusName?.toLowerCase() === 'failed'
                                                        ? '#d32f2f'
                                                        : '#FF4C00',
                                                color: '#fff'
                                            }}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        });
    };

    // ============ PERMISSION CHECK ============

    if (!allowedRoles.includes(role)) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
                <Typography variant="h5" fontWeight={600} color="error">
                    403 Unauthorized Access
                </Typography>
            </Box>
        );
    }

    // ============ RENDER ============

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
            <Typography
                variant="h5"
                sx={{
                    textAlign: 'center',
                    fontSize: { xs: '1.25rem', sm: '1.5rem' },
                    fontWeight: 600, mb: 0.7
                }}
            >
                Re-Assign Inquiry List
            </Typography>

            {/* Controls */}
            <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                {isSmallScreen && (
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Search by firm, contact or mobile..."
                            value={mobileSearchQuery}
                            onChange={(e) => setMobileSearchQuery(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                            }}
                        />
                    </Grid>
                )}

                <Grid item xs={12} md={5}>
                    <Dropdown
                        label="Re-Assign To"
                        value={reAssignToUserId}
                        options={usersOptions}
                        valueKey="UserId"
                        labelKey="employeeName"
                        onChange={(selected) => setReAssignToUserId(selected.UserId)}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={7}>
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: { xs: 'stretch', md: 'flex-end' } }}>
                        <Button variant="contained" onClick={handleSubmit} fullWidth={isSmallScreen}>
                            Submit
                        </Button>
                        <Button variant="outlined" onClick={handleReset} fullWidth={isSmallScreen}>
                            Reset
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            {/* Selected Count Bar (Mobile) */}
            {isSmallScreen && selectionModel.length > 0 && (
                <Paper sx={{ p: 1.5, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox {...getHeaderCheckboxProps()} onChange={handleHeaderCheckboxChange} />
                        <Typography>{selectionModel.length} selected</Typography>
                    </Box>
                </Paper>
            )}

            {/* Content */}
            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {isSmallScreen ? (
                        <Box sx={{ p: 2, maxHeight: '70vh', overflowY: 'auto' }}>
                            {renderCards()}
                        </Box>
                    ) : (
                        <Box sx={{ height: '74vh', width: '100%' }}>
                            {loading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <>
                                    {rows?.length === 0 ? (
                                        <NoDataComponent />
                                    ) : (
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            getRowId={(r) => r.InqId}

                                            pagination
                                            paginationMode="server"
                                            rowCount={totalCount}

                                            paginationModel={paginationModel}
                                            onPaginationModelChange={(model) => setPaginationModel(model)}

                                            pageSizeOptions={[25, 50, 100]}
                                            loading={loading}
                                            checkboxSelection={false}
                                            disableSelectionOnClick
                                            getRowHeight={() => 'auto'}

                                            filterMode="server"
                                            filterModel={filterModel}
                                            onFilterModelChange={setFilterModel}

                                            sortingMode="server"
                                            sortModel={sortModel}
                                            onSortModelChange={setSortModel}

                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                                                '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },
                                                '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                                                '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },
                                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                                                '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },
                                                '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },
                                                '& .MuiDataGrid-cell': {
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                            }}
                                            slots={{
                                                noResultsOverlay: CustomNoDataOverlay
                                            }}
                                        />
                                    )
                                    }
                                </>
                            )}
                        </Box>
                    )}
                </Box>
            </Paper>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default ReAssignInquiryDetails2;